import React from "react";
import { array, string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import PhotoStoryCard from "../../molecules/PhotoStoryCard";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import { getSlug, getCollectionName } from "../../utils/utils";

import "./photoStoryWithSlider.m.css";

const PhotoStoryWithSlider = ({ collection, sections, publisherAttributes, domainSlug }) => {
  const stories = get(collection, ["items"], [])
    .filter((item) => item.type === "story")
    .slice(0, 4);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);

  if (!stories.length) {
    return null;
  }

  const photoStoryStack = stories.map((story, index) => {
    const imageType = (index) => (index === 1 ? "image2x1" : "image1x1");
    const aspectRatio = (index) => (index === 1 ? [2, 1] : [1, 1]);
    const calculateWidths = () => {
      if (global.deviceWidth < 876) {
        return index <= 1 ? [400] : [250];
      } else {
        return index <= 1 ? [650] : [320];
      }
    };
    const storyHeadlineStyle =
      index === 0
        ? `${publisherAttributes.lang}-story-headline-first`
        : `${publisherAttributes.lang}-story-headline-rest`;
    const getHeaderType = (index) => {
      switch (index) {
        case 0:
          return 31;
        case 1:
          return 3;
        default:
          return 20;
      }
    };

    return (
      <PhotoStoryCard
        key={index}
        story={story.story}
        headerLevel={2}
        headlineType={getHeaderType(index)}
        imageType={imageType(index)}
        cardImageWidths={calculateWidths()}
        aspectRatio={aspectRatio(index)}
        headlineStyle={storyHeadlineStyle}
      />
    );
  });

  return (
    <div styleName="base" className="photo-story-slider" data-testid="slider-photo">
      <div styleName="wrapper">
        {showCollectionName && (
          <CollectionTitleWithArrow
            collectionName={collectionName}
            collectionSlug={collectionSlug}
            headlineClassName="collection-name-arrow"
            updatedFont={true}
          />
        )}
        <div styleName="photo-story-wrapper">{photoStoryStack}</div>
      </div>
    </div>
  );
};

PhotoStoryWithSlider.propTypes = {
  stories: array,
  collection: object,
  collectionName: string,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

PhotoStoryWithSlider.storyLimit = 4;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps, null)(PhotoStoryWithSlider);
